/**
 * Renders the modals owned directly by CoverageDetails: the Report Inaccuracy
 * (`EvBvModal`) flow and the Validate EV (`ValidateEvModal`) flow. Each modal
 * is gated on its own visibility signal so the parent can keep both flows
 * decoupled (Redux-driven vs local state-driven).
 */
import React from "react";
import EvBvModal from "../../../../components/modals/ebvbModal/EvbvModal";
import ValidateEvModal from "../../../../components/modals/validateEvModal/ValidateEvModal";
import {
  CoverageResult,
  Demographics,
  SingleCoverage,
} from "../../../../data-model/medicalPaOrdersModel";
import { ModalId } from "../../../../enums/modalId";

interface CoverageDetailsModalsProps {
  openedModalId: string | null | undefined;
  showValidateModal: boolean;
  onCloseEvBvModal: () => void;
  onCloseValidateModal: () => void;
  orderId: string;
  activeTabIndex: number;
  demographicsData: Demographics | undefined;
  orderedCoverages: SingleCoverage[];
  coverageResults: CoverageResult[];
  activeCoverageResultForValidateEv: CoverageResult | undefined;
  /** Full coverage endpoint payload, rendered verbatim in the Validate EV raw-response view. */
  coverageResponse: {
    coverages: SingleCoverage[];
    coverage_results: CoverageResult[];
  };
}

export const CoverageDetailsModals: React.FC<CoverageDetailsModalsProps> = ({
  openedModalId,
  showValidateModal,
  onCloseEvBvModal,
  onCloseValidateModal,
  orderId,
  activeTabIndex,
  demographicsData,
  orderedCoverages,
  coverageResults,
  activeCoverageResultForValidateEv,
  coverageResponse,
}) => {
  return (
    <>
      {openedModalId === ModalId.EVBV_MODAL && (
        <EvBvModal
          onClose={onCloseEvBvModal}
          demographicsData={demographicsData}
          orderId={orderId}
          activeTabIndex={activeTabIndex}
          coverageData={orderedCoverages}
        />
      )}
      {showValidateModal && (
        <ValidateEvModal
          onClose={onCloseValidateModal}
          id={orderId || ""}
          activeTabIndex={activeTabIndex}
          activeCoverageResult={activeCoverageResultForValidateEv}
          coverageResults={coverageResults}
          fullCoverageResponse={coverageResponse}
          orderId={orderId}
          demographics={demographicsData ?? {}}
        />
      )}
    </>
  );
};
